import { render, staticRenderFns } from "./employeeDetails.vue?vue&type=template&id=93b20492&scoped=true"
import script from "./employeeDetails.vue?vue&type=script&lang=js"
export * from "./employeeDetails.vue?vue&type=script&lang=js"
import style0 from "./employeeDetails.vue?vue&type=style&index=0&id=93b20492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b20492",
  null
  
)

export default component.exports